import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { FriendsPage } from '@/features/profiles'

const amigosSearchSchema = z.object({
  tab: z.enum(['list', 'search']).optional()
})

export const Route = createFileRoute('/_authenticated/_main/amigos/')({
  validateSearch: amigosSearchSchema,
  component: FriendsPage
})
